export async function attendanceRequest(url, body, signal) {
  const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal });
  const payload = await response.json();
  if (!response.ok || !payload.status) throw new Error(payload.message || 'Unable to complete the attendance request.');
  return payload;
}

export const newSubmissionKey = () => window.crypto?.randomUUID?.() || `attendance-${Date.now()}-${Math.random().toString(36).slice(2)}`;
